import React, { useEffect, useRef, useState } from "react";

import { Link } from "react-router-dom";

import api, { API } from "@/lib/api";

import MarketingLayout from "@/components/layout/MarketingLayout";

import useScrollReveal from "@/lib/useScrollReveal";

import { ArrowUpRight, X, ChevronLeft, ChevronRight, MessageCircle, Globe, PhoneCall, ChevronDown, Star, Plus } from "lucide-react";

import WeddingStoriesSection, { StoryModal } from "@/components/WeddingStories";

import heroCoverImg from "@/Assets/DSC02292.JPG.jpeg";



const reasons = [

  {

    num: "I",

    title: "Founder-Led Creative Direction",

    desc: "Every commission is personally steered from initial consultation to final color timing. Creative direction remains singular, ensuring consistent emotional depth across your full celebrations.",

    img: "https://images.unsplash.com/photo-1519741497674-611481863552?q=80&w=1000&auto=format&fit=crop",

    slideDirection: "-translate-x-12",

  },

  {

    num: "II",

    title: "1200+ Weddings Across Ten Years",

    desc: "Since 2010, we have documented celebrations across Pakistan and international destination venues, developing an instinctual understanding of multi-day cultural cadence and heritage storytelling at scale.",

    img: "https://images.unsplash.com/photo-1583939003579-730e3918a45a?q=80&w=1000&auto=format&fit=crop",

    slideDirection: "translate-y-12",

  },

  {

    num: "III",

    title: "International Destination Practice",

    desc: "Regularly commissioned by families based in the UK, USA, UAE, Canada, and Australia — coordinating seamlessly across time zones to meticulously plan ceremony schedules before arrival.",

    img: "https://images.unsplash.com/photo-1511795409834-ef04bbd61622?q=80&w=1000&auto=format&fit=crop",

    slideDirection: "translate-x-12",

  },

  {

    num: "IV",

    title: "A Team Trained to Our Exact Standard",

    desc: "Our core cinema and camera artists work under direct supervision. When covering your celebrations, they shoot with the same deliberate discipline, identical color science, and unwavering quietness.",

    img: "https://images.unsplash.com/photo-1509631179647-0177331693ae?q=80&w=1000&auto=format&fit=crop",

    slideDirection: "-translate-x-12",

  },

  {

    num: "V",

    title: "Calm Under Wedding-Day Pressure",

    desc: "Subcontinental celebrations are intricate: run-times shift, lighting dims, emotions run intense. Having witnessed it all, our composure, gentleness, and timing ensure no sacred moment is missed.",

    img: "https://images.unsplash.com/photo-1606800052052-a08af7148866?q=80&w=1000&auto=format&fit=crop",

    slideDirection: "translate-y-12",

  },

  {

    num: "VI",

    title: "Thoughtful Films & Heirloom Albums",

    desc: "Online proofing archives delivered within days. Master wedding cinema and archival hand-bound Italian linen albums crafted individually with the exact reverence given to fine art prints.",

    img: "https://images.unsplash.com/photo-1492691527719-9d1e07e534b4?q=80&w=1000&auto=format&fit=crop",

    slideDirection: "translate-x-12",

  },

];



export default function Home() {

  const [testimonials, setTestimonials] = useState([]);

  const [galleryImages, setGalleryImages] = useState([]);

  const [cardsVisible, setCardsVisible] = useState(false);

  const [showWaMenu, setShowWaMenu] = useState(false);

 

  const [showReviewModal, setShowReviewModal] = useState(false);

  const [newReview, setNewReview] = useState({ client_name: "", role: "", quote: "", rating: 5 });

  const [submitting, setSubmitting] = useState(false);

  const scrollContainerRef = useRef(null);



  const reasonsSectionRef = useRef(null);

  const waMenuRef = useRef(null);



  useEffect(() => {

    api

      .get("/media", { params: { visibility: "public" } })

      .then(({ data }) => {

        const list = Array.isArray(data) ? data : [];

        const uploadedImages = list

          .filter(

            (m) =>

              m.media_type !== "youtube" &&

              m.media_type !== "video" &&

              (!m.url || !m.url.includes("youtube")) &&

              m.category !== "story"

          )

          .map((m) => `${API}/media/file/${m.id}`);

        setGalleryImages(uploadedImages);

      })

      .catch(() => setGalleryImages([]));



    setTestimonials([

      {

        id: "1",

        client_name: "Soha",

        role: "SOHAAGAWADE",

        quote: "Absolutely loving all pictures. Couldn’t have chosen anyone else than Dobhai for my big day",

        rating: 5,

      },

      {

        id: "2",

        client_name: "M. Umair Arshad",

        role: "VERIFIED CLIENT",

        quote: "Very professional people to work with, highly trained and extremely respectful. The whole team was really cooperative, and I had a really good experience. *Highly Recommended*",

        rating: 5,

      },

      {

        id: "3",

        client_name: "Adnan Kadri",

        role: "VERIFIED CLIENT",

        quote: "Alhamdulillah..Thank you so much for capturing our wedding so beautifully. We truly appreciate your professionalism, creativity, and the care you put into every moment. It was a pleasure working with you, and we’re so grateful to have these memories to cherish.",

        rating: 5,

      },

    ]);



    // Auto-scroll loop effect for testimonials

    const interval = setInterval(() => {

      if (scrollContainerRef.current) {

        const { scrollLeft, scrollWidth, clientWidth } = scrollContainerRef.current;

        const scrollAmount = 420;

        if (scrollLeft + clientWidth >= scrollWidth - 10) {

          scrollContainerRef.current.scrollTo({ left: 0, behavior: "smooth" });

        } else {

          scrollContainerRef.current.scrollBy({ left: scrollAmount, behavior: "smooth" });

        }

      }

    }, 3500);



    const observer = new IntersectionObserver(

      ([entry]) => {

        if (entry.isIntersecting) {

          setCardsVisible(true);

        }

      },

      { threshold: 0.15 }

    );



    if (reasonsSectionRef.current) observer.observe(reasonsSectionRef.current);



    const handleClickOutside = (e) => {

      if (waMenuRef.current && !waMenuRef.current.contains(e.target)) {

        setShowWaMenu(false);

      }

    };

    document.addEventListener("mousedown", handleClickOutside);



    return () => {

      clearInterval(interval);

      observer.disconnect();

      document.removeEventListener("mousedown", handleClickOutside);

    };

  }, []);



  useScrollReveal([testimonials.length]);



  const scrollReviews = (direction) => {

    if (scrollContainerRef.current) {

      const scrollAmount = direction === "left" ? -420 : 420;

      scrollContainerRef.current.scrollBy({ left: scrollAmount, behavior: "smooth" });

    }

  };



  const handleAddReview = (e) => {

    e.preventDefault();

    if (!newReview.client_name || !newReview.quote) return;

    setSubmitting(true);



    const reviewObj = {

      id: Date.now().toString(),

      client_name: newReview.client_name,

      role: newReview.role || "VERIFIED CLIENT",

      quote: newReview.quote,

      rating: Number(newReview.rating) || 5,

    };



    api.post("/testimonials", reviewObj)

      .then(() => {

        setTestimonials((prev) => [reviewObj, ...(Array.isArray(prev) ? prev : [])]);

        setNewReview({ client_name: "", role: "", quote: "", rating: 5 });

        setShowReviewModal(false);

        setSubmitting(false);

      })

      .catch(() => {

        setTestimonials((prev) => [reviewObj, ...(Array.isArray(prev) ? prev : [])]);

        setNewReview({ client_name: "", role: "", quote: "", rating: 5 });

        setShowReviewModal(false);

        setSubmitting(false);

      });

  };



  return (

    <MarketingLayout>

      {/* 1. Hero Section */}

      <section className="relative overflow-hidden bg-olive-gradient" data-testid="hero-section">

        <div className="absolute inset-0 grain pointer-events-none opacity-60" />

        <div className="grid grid-cols-1 lg:grid-cols-12 min-h-[88vh] relative">

          <div className="lg:col-span-5 flex items-center px-6 md:px-12 lg:px-20 py-16 lg:py-0">

            <div>

              <div className="overline text-primary mb-6 flex items-center gap-3">

                <span className="w-10 h-px bg-primary" /> Photography · Est. 2010

              </div>

              <h1 className="font-serif text-5xl md:text-7xl lg:text-[88px] leading-[0.98] tracking-tight font-semibold text-foreground">

                Dobhai.<br />

                <span className=" text-primary font-medium">Crafting Tales Of Love.</span>

              </h1>

              <p className="mt-8 text-base md:text-lg text-muted-foreground max-w-md leading-relaxed font-light">

                Welcome to the house of premium wedding photography and bespoke visual legacy.

              </p>

              <div className="mt-10 flex flex-wrap items-center gap-4">

                <Link to="/booking" className="btn-premium" data-testid="hero-book-btn">

                  Book a Session <ArrowUpRight size={14} strokeWidth={1.6} className="ml-2" />

                </Link>

                <Link to="/portfolio" className="btn-primary" data-testid="hero-portfolio-btn">

                  View Portfolio

                </Link>

              </div>

              <div className="mt-16 flex gap-12 text-sm text-muted-foreground pt-8 border-t border-olive-soft/40">

                <div>

                  <div className="font-serif text-4xl text-foreground font-semibold">1200+</div>

                  <div className="overline mt-2 text-primary/80">Weddings</div>

                </div>

                <div>

                  <div className="font-serif text-4xl text-foreground font-semibold">5</div>

                  <div className="overline mt-2 text-primary/80">Countries</div>

                </div>

                <div>

                  <div className="font-serif text-4xl text-foreground font-semibold">16y</div>

                  <div className="overline mt-2 text-primary/80">Crafted</div>

                </div>

              </div>

            </div>

          </div>

          <div className="lg:col-span-7 relative min-h-[60vh] lg:min-h-[88vh] overflow-hidden bg-[#141F14]">

            <img

              src={heroCoverImg}

              alt=""

              aria-hidden="true"

              className="absolute inset-0 w-full h-full object-cover blur-2xl scale-110 opacity-50"

            />

            <img

              src={heroCoverImg}

              alt="Bride and groom resting near bed"

              className="absolute inset-0 w-full h-full object-cover transition-transform duration-[2000ms] ease-out"

              style={{ objectPosition: 'center 65%' }}

            />

            <div className="absolute inset-0 bg-gradient-to-tr from-[#283828]/55 via-[#283828]/15 to-transparent" />

            <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-[#283828]/40 to-transparent" />

          </div>

        </div>

      </section>



      {/* 2. Full Wedding Stories Component Call */}

      <WeddingStoriesSection />



      {/* 3. Why Couples Choose Us (Architectural 6-Grid) */}

      <section

        ref={reasonsSectionRef}

        className="py-24 md:py-36 bg-[#FAF9F5] border-b border-olive-soft relative overflow-hidden"

        data-testid="reasons-section"

      >

        <div className="container-x relative">

          <div className="relative mb-20 md:mb-24 select-none">

            <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-end">

              <div className="lg:col-span-7">

                <div className="flex items-center gap-3 mb-6 overflow-hidden">

                  <span

                    className={`h-px bg-primary/70 transition-all duration-1000 ease-out origin-left ${

                      cardsVisible ? "w-12 opacity-100" : "w-0 opacity-0"

                    }`}

                  />

                  <span className="inline-flex items-center gap-2 text-[10px] tracking-[0.32em] uppercase font-mono font-medium text-primary">

                    <span className="w-1.5 h-1.5 rounded-full bg-primary/80 animate-pulse" />

                    Why Dobhai Official

                  </span>

                </div>



                <h2 className="font-serif text-4xl sm:text-6xl lg:text-[66px] leading-[1.04] font-normal tracking-tight text-foreground">

                  <span className="block overflow-hidden">

                    <span

                      className={`block transition-transform duration-700 ease-out ${

                        cardsVisible ? "translate-y-0" : "translate-y-full"

                      }`}

                    >

                      Six reasons serious

                    </span>

                  </span>

                  <span className="block overflow-hidden mt-1">

                    <span

                      className={`block transition-transform duration-700 delay-150 ease-out ${

                        cardsVisible ? "translate-y-0" : "translate-y-full"

                      }`}

                    >

                      couples choose{" "}

                      <span className="italic font-serif text-primary font-normal">

                        us.

                      </span>

                    </span>

                  </span>

                </h2>

              </div>



              <div className="lg:col-span-5 lg:pl-6">

                <div

                  className={`relative pl-7 border-l border-primary/25 transition-all duration-1000 delay-300 ease-out ${

                    cardsVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-6"

                  }`}

                >

                  <p className="text-xs sm:text-sm md:text-[15px] leading-relaxed text-muted-foreground font-light tracking-wide">

                    Not the cheapest studio in Islamabad. Not the most prolific. But arguably the most intentional — and for couples who care deeply about how their wedding is documented, the most worthwhile.

                  </p>



                  <div className="mt-5 flex items-center gap-3 text-[10px] uppercase font-mono tracking-[0.25em] text-primary/70">

                    <span>Est. 2010</span>

                    <span>·</span>

                    <span>Bespoke Retinue</span>

                  </div>

                </div>

              </div>

            </div>

          </div>



          <div className="grid grid-cols-2 lg:grid-cols-3 border-t border-l border-olive-soft bg-card/70 overflow-hidden shadow-sm">

            {reasons.map((item, idx) => (

              <div

                key={item.num}

                style={{ transitionDelay: `${idx * 80}ms` }}

                className={`group relative p-4 sm:p-8 md:p-11 border-r border-b border-olive-soft cursor-pointer flex flex-col justify-between min-h-[300px] sm:min-h-[350px] transition-all duration-700 ease-out ${

                  cardsVisible

                    ? "opacity-100 translate-x-0 translate-y-0"

                    : `opacity-0 ${item.slideDirection}`

                }`}

              >

                <img

                  src={galleryImages[idx] || item.img}

                  alt={item.title}

                  className="absolute inset-0 w-full h-full object-cover opacity-0 group-hover:opacity-40 group-hover:scale-105 transition-all duration-700 ease-out pointer-events-none"

                />



                <div className="absolute inset-0 bg-[#162016] opacity-0 group-hover:opacity-90 transition-opacity duration-500 pointer-events-none" />



                <div className="absolute top-0 left-0 w-full h-[2px] bg-primary scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left z-10" />



                <div className="relative z-10">

                  <span className="font-serif text-xl sm:text-2xl md:text-3xl text-primary group-hover:text-[#C9D1B5] font-light block mb-3 sm:mb-5 transition-colors duration-500">

                    {item.num}

                  </span>



                  <h3 className="font-serif text-lg sm:text-xl md:text-2xl text-foreground group-hover:text-white font-semibold mb-2 sm:mb-3 leading-snug transition-colors duration-500">

                    {item.title}

                  </h3>



                  <p className="text-[11px] sm:text-xs md:text-sm text-muted-foreground group-hover:text-[#CBD5C0] leading-relaxed font-light transition-colors duration-500">

                    {item.desc}

                  </p>

                </div>



                <div className="relative z-10 mt-6 sm:mt-8 pt-3 sm:pt-4 border-t border-olive-soft/50 group-hover:border-white/20 flex items-center justify-between transition-colors duration-500">

                  <span className="text-[10px] tracking-widest font-mono text-muted-foreground/60 group-hover:text-[#C9D1B5] transition-colors">

                    0{idx + 1} //

                  </span>

                  <ArrowUpRight

                    size={15}

                    className="text-primary group-hover:text-[#C9D1B5] opacity-0 group-hover:opacity-100 transform translate-y-2 group-hover:translate-y-0 transition-all duration-300"

                  />

                </div>

              </div>

            ))}

          </div>

        </div>

      </section>



      {/* 4. Testimonials (Auto-Sliding with Manual Arrows & Wfolio Card) */}

      <section className="py-24 md:py-32 bg-[#F9F8F4] border-b border-olive-soft relative overflow-hidden" data-testid="testimonials-section">

        <div className="container-x max-w-7xl mx-auto px-6">

          <div className="flex flex-col md:flex-row md:items-end justify-between mb-14">

            <div>

              <div className="text-[10px] uppercase tracking-[0.35em] text-primary mb-3 font-mono">

                WHAT OUR COUPLES SAY

              </div>

              <h2 className="font-serif text-4xl sm:text-5xl md:text-6xl text-foreground font-normal tracking-tight leading-tight">

                All five stars.<br />

                <span className="italic font-serif text-primary font-normal">Every single one.</span>

              </h2>

            </div>



            <div className="mt-6 md:mt-0 flex items-center gap-4">

              <button

                onClick={() => setShowReviewModal(true)}

                className="px-6 py-3 bg-[#283828] text-white font-medium text-xs tracking-[0.2em] uppercase hover:bg-primary transition-colors inline-flex items-center gap-2 shadow-sm rounded-full"

              >

                <Plus size={15} /> Add Your Review

              </button>



              <div className="flex gap-2">

                <button

                  onClick={() => scrollReviews("left")}

                  className="w-11 h-11 rounded-full border border-olive-soft bg-card flex items-center justify-center text-foreground hover:bg-primary hover:text-white transition-colors cursor-pointer"

                  title="Scroll Left"

                >

                  <ChevronLeft size={18} />

                </button>

                <button

                  onClick={() => scrollReviews("right")}

                  className="w-11 h-11 rounded-full border border-olive-soft bg-card flex items-center justify-center text-foreground hover:bg-primary hover:text-white transition-colors cursor-pointer"

                  title="Scroll Right"

                >

                  <ChevronRight size={18} />

                </button>

              </div>

            </div>

          </div>



          <div className="mb-12 flex flex-wrap items-center gap-10 sm:gap-16 text-xs font-mono uppercase tracking-[0.2em] text-muted-foreground border-y border-olive-soft/60 py-6">

            <div>

              <span className="font-serif text-2xl sm:text-3xl text-foreground block normal-case font-normal mb-1">100%</span>

              VERIFIED REVIEWS

            </div>

            <div className="w-px h-8 bg-olive-soft/85 hidden sm:block" />

            <div>

              <span className="font-serif text-2xl sm:text-3xl text-foreground block normal-case font-normal mb-1">5.0</span>

              AVERAGE RATING

            </div>

            <div className="w-px h-8 bg-olive-soft/85 hidden sm:block" />

            <div className="flex flex-col">

              <div className="flex gap-1 text-primary mb-1">

                {[...Array(5)].map((_, i) => (

                  <Star key={i} size={14} fill="currentColor" stroke="none" />

                ))}

              </div>

              ALL FIVE STARS

            </div>

          </div>



          <div

            ref={scrollContainerRef}

            className="flex gap-6 overflow-x-auto pb-16 pt-8 px-4 scrollbar-none snap-x snap-mandatory scroll-smooth items-center"

            style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}

          >

            {Array.isArray(testimonials) && testimonials.map((t) => (

              <div

                key={t.id || Math.random()}

                className="bg-card p-10 md:p-12 flex flex-col justify-between relative border border-olive-soft rounded-[2px] w-[340px] sm:w-[400px] h-[380px] flex-shrink-0 snap-center transition-all duration-500 ease-out hover:scale-105 hover:-translate-y-2 hover:shadow-2xl hover:z-40 hover:border-primary hover:bg-[#FAF8F3]"

                data-testid={`testimonial-${t.id}`}

              >

                <div>

                  <div className="flex gap-1 text-primary mb-4">

                    {[...Array(t.rating || 5)].map((_, i) => (

                      <Star key={i} size={14} fill="currentColor" stroke="none" />

                    ))}

                  </div>



                  <p className="font-serif text-base md:text-[17px] leading-relaxed font-normal text-foreground/90 italic line-clamp-5">

                    "{t.quote}"

                  </p>

                </div>



                <div className="pt-4 border-t border-olive-soft/60 flex items-center justify-between">

                  <div>

                    <div className="text-xs font-semibold tracking-wide text-foreground uppercase truncate max-w-[220px]">

                      {t.client_name}

                    </div>

                    <div className="text-[10px] tracking-[0.2em] uppercase font-mono text-muted-foreground mt-0.5 truncate max-w-[220px]">

                      {t.role}

                    </div>

                  </div>

                  <span className="text-[10px] font-mono text-primary/70 uppercase">Verified</span>

                </div>

              </div>

            ))}



            <a

              href="https://dobhaiofficials.wfolio.pro/comments"

              target="_blank"

              rel="noopener noreferrer"

              className="bg-[#283828] text-white p-10 md:p-12 flex flex-col justify-between relative border border-[#283828] rounded-[2px] w-[340px] sm:w-[400px] h-[380px] flex-shrink-0 snap-center transition-all duration-500 ease-out hover:scale-105 hover:-translate-y-2 hover:shadow-2xl hover:z-40 hover:bg-primary group"

            >

              <div>

                <div className="flex gap-1 text-[#C9D1B5] mb-4">

                  {[...Array(5)].map((_, i) => (

                    <Star key={i} size={14} fill="currentColor" stroke="none" />

                  ))}

                </div>



                <p className="font-serif text-xl md:text-2xl leading-snug font-normal text-white/95">

                  Read every verified review directly on our Wfolio Pro portal.

                </p>

              </div>



              <div className="pt-4 border-t border-white/20 flex items-center justify-between">

                <span className="text-xs font-semibold tracking-[0.2em] uppercase text-[#C9D1B5]">

                  View Wfolio Reviews

                </span>

                <ArrowUpRight size={18} className="text-[#C9D1B5] transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />

              </div>

            </a>

          </div>

        </div>

      </section>



      {/* Review Submission Modal */}

      {showReviewModal && (

        <div className="fixed inset-0 z-[110] flex items-center justify-center bg-black/70 backdrop-blur-sm p-4">

          <div className="bg-[#FAF8F3] border border-olive-soft max-w-lg w-full p-8 relative rounded-[2px] shadow-2xl">

            <button

              onClick={() => setShowReviewModal(false)}

              className="absolute top-6 right-6 text-foreground hover:text-primary transition-colors"

            >

              <X size={20} />

            </button>



            <div className="mb-6">

              <span className="text-[10px] uppercase font-mono tracking-[0.3em] text-primary block mb-1">

                PATRON EXPERIENCE

              </span>

              <h3 className="font-serif text-2xl md:text-3xl text-foreground">

                Share your review

              </h3>

            </div>



            <form onSubmit={handleAddReview} className="space-y-4">

              <div>

                <label className="block text-xs uppercase font-mono tracking-wider text-muted-foreground mb-1.5">

                  Your Name / Couple Name *

                </label>

                <input

                  type="text"

                  required

                  value={newReview.client_name}

                  onChange={(e) => setNewReview({ ...newReview, client_name: e.target.value })}

                  placeholder="e.g. Ayesha & Usman"

                  className="w-full px-4 py-3 bg-card border border-olive-soft text-foreground text-sm focus:outline-none focus:border-primary"

                />

              </div>



              <div>

                <label className="block text-xs uppercase font-mono tracking-wider text-muted-foreground mb-1.5">

                  Review Source / Title

                </label>

                <input

                  type="text"

                  value={newReview.role}

                  onChange={(e) => setNewReview({ ...newReview, role: e.target.value })}

                  placeholder="e.g. Google Review · 5 Stars"

                  className="w-full px-4 py-3 bg-card border border-olive-soft text-foreground text-sm focus:outline-none focus:border-primary"

                />

              </div>



              <div>

                <label className="block text-xs uppercase font-mono tracking-wider text-muted-foreground mb-2">

                  Select Rating *

                </label>

                <div className="flex items-center gap-2">

                  {[1, 2, 3, 4, 5].map((star) => (

                    <button

                      key={star}

                      type="button"

                      onClick={() => setNewReview({ ...newReview, rating: star })}

                      className="p-1 text-primary focus:outline-none transition-transform hover:scale-110"

                    >

                      <Star

                        size={22}

                        fill={star <= newReview.rating ? "currentColor" : "none"}

                        className={star <= newReview.rating ? "text-primary" : "text-olive-soft"}

                      />

                    </button>

                  ))}

                  <span className="ml-2 text-xs font-mono text-muted-foreground">

                    ({newReview.rating} / 5 Stars)

                  </span>

                </div>

              </div>



              <div>

                <label className="block text-xs uppercase font-mono tracking-wider text-muted-foreground mb-1.5">

                  Your Experience / Quote *

                </label>

                <textarea

                  required

                  rows={4}

                  value={newReview.quote}

                  onChange={(e) => setNewReview({ ...newReview, quote: e.target.value })}

                  placeholder="Describe your photography experience..."

                  className="w-full px-4 py-3 bg-card border border-olive-soft text-foreground text-sm focus:outline-none focus:border-primary resize-none"

                />

              </div>



              <div className="pt-2 flex justify-end gap-3">

                <button

                  type="button"

                  onClick={() => setShowReviewModal(false)}

                  className="px-5 py-3 border border-olive-soft text-foreground text-xs uppercase tracking-widest hover:bg-card transition-colors"

                >

                  Cancel

                </button>

                <button

                  type="submit"

                  disabled={submitting}

                  className="px-6 py-3 bg-[#283828] text-white text-xs uppercase tracking-widest hover:bg-primary transition-colors disabled:opacity-50"

                >

                  {submitting ? "Submitting..." : "Post Review"}

                </button>

              </div>

            </form>

          </div>

        </div>

      )}



      {/* 5. LUXURY EDITORIAL CTA SECTION WITH DUAL WHATSAPP */}

      <section className="relative py-28 md:py-36 overflow-hidden bg-[#162016] text-[#F1F2EC]" data-testid="cta-section">

        <div className="absolute inset-0 pointer-events-none select-none">

          <img

            src="https://images.unsplash.com/photo-1519741497674-611481863552?q=80&w=1600&auto=format&fit=crop"

            alt=""

            className="w-full h-full object-cover opacity-20 filter grayscale scale-105"

          />

          <div className="absolute inset-0 bg-gradient-to-b from-[#141F14]/95 via-[#162016]/90 to-[#121A12]/98" />

          <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-[#2E422E]/25 via-transparent to-transparent" />

        </div>



        <div className="container-x relative text-center z-10">

          <div className="inline-flex items-center justify-center gap-2 mb-6">

            <span className="text-[10px] uppercase font-mono tracking-[0.35em] text-[#C9D1B5]/85">

              LIMITED AVAILABILITY · 2026 & 2027

            </span>

          </div>



          <h2 className="font-serif text-5xl sm:text-6xl md:text-7xl lg:text-[82px] font-normal leading-[1.04] tracking-tight max-w-4xl mx-auto">

            Your wedding<br />

            <span className="italic font-serif text-[#C9D1B5]">deserves art.</span>

          </h2>



          <p className="mt-6 md:mt-8 text-xs sm:text-sm md:text-base text-[#A8B29C] max-w-2xl mx-auto font-light leading-relaxed">

            Most November–February dates are booked between July and September. If your date matters to you, reach out early.

          </p>



          <div className="mt-12 flex flex-wrap items-center justify-center gap-4 relative">

            <Link

              to="/booking"

              className="px-8 sm:px-10 py-4 bg-[#D1BC8A] text-[#1A241A] font-semibold text-[11px] tracking-[0.25em] uppercase hover:bg-[#decda2] transition-all duration-300 shadow-lg hover:shadow-2xl hover:-translate-y-0.5"

            >

              Begin Your Enquiry

            </Link>



            <div className="relative" ref={waMenuRef}>

              <button

                type="button"

                onClick={() => setShowWaMenu((prev) => !prev)}

                className="px-7 sm:px-8 py-4 border border-white/20 bg-black/25 backdrop-blur-md text-white/95 font-medium text-[11px] tracking-[0.22em] uppercase hover:border-[#C9D1B5] hover:text-[#C9D1B5] transition-all duration-300 inline-flex items-center gap-2 cursor-pointer shadow-md"

              >

                <MessageCircle size={15} className="text-[#C9D1B5]" />

                <span>WhatsApp Us</span>

                <ChevronDown size={14} className={`text-[#C9D1B5] transition-transform duration-300 ${showWaMenu ? "rotate-180" : ""}`} />

              </button>



              {showWaMenu && (

                <div className="absolute left-1/2 -translate-x-1/2 bottom-full mb-3 w-72 sm:w-80 bg-[#121B12]/98 border border-[#2E422E] backdrop-blur-xl shadow-2xl p-2 rounded-[2px] z-50 animate-fadeIn text-left">

                  <div className="px-3 py-2 border-b border-white/10 mb-1">

                    <span className="text-[9px] uppercase font-mono tracking-[0.25em] text-[#C9D1B5]/80 block">

                      Connect with Atelier

                    </span>

                  </div>



                  <a

                    href="https://wa.me/923235464594?text=Hello%20Dobhai%20Official,%20I%20would%20like%20to%20enquire%20regarding%20dates%20and%20commission%20availability%20for%20wedding%20coverage."

                    target="_blank"

                    rel="noopener noreferrer"

                    onClick={() => setShowWaMenu(false)}

                    className="group flex items-start gap-3 p-3 hover:bg-[#1C281C] transition-colors rounded-[1px]"

                  >

                    <div className="w-8 h-8 rounded-full bg-white/5 border border-white/10 flex items-center justify-center text-[#C9D1B5] flex-shrink-0 group-hover:border-[#C9D1B5]">

                      <PhoneCall size={14} />

                    </div>

                    <div>

                      <div className="text-xs font-serif text-white group-hover:text-[#C9D1B5] transition-colors flex items-center gap-2">

                        <span>Pakistan Enquiries</span>

                        <span className="text-[9px] font-mono px-1.5 py-0.5 bg-white/10 rounded text-[#C9D1B5]">PK</span>

                      </div>

                      <div className="text-[11px] text-muted-foreground font-mono mt-0.5">+92 323 5464594</div>

                    </div>

                  </a>



                  <a

                    href="https://wa.me/97450538523?text=Hello%20Dobhai%20Official,%20I%20would%20like%20to%20enquire%20regarding%20dates%20and%20commission%20availability%20for%20upcoming%20wedding%20coverage."

                    target="_blank"

                    rel="noopener noreferrer"

                    onClick={() => setShowWaMenu(false)}

                    className="group flex items-start gap-3 p-3 hover:bg-[#1C281C] transition-colors rounded-[1px] border-t border-white/5"

                  >

                    <div className="w-8 h-8 rounded-full bg-white/5 border border-white/10 flex items-center justify-center text-[#C9D1B5] flex-shrink-0 group-hover:border-[#C9D1B5]">

                      <Globe size={14} />

                    </div>

                    <div>

                      <div className="text-xs font-serif text-white group-hover:text-[#C9D1B5] transition-colors flex items-center gap-2">

                        <span>Destination & Overseas Desk</span>

                        <span className="text-[9px] font-mono px-1.5 py-0.5 bg-white/10 rounded text-[#C9D1B5]">DESK</span>

                      </div>

                      <div className="text-[11px] text-muted-foreground font-mono md:mt-0.5">+974 5053 8523</div>

                    </div>

                  </a>

                </div>

              )}

            </div>



            <Link

              to="/portfolio"

              className="px-7 sm:px-8 py-4 border border-white/20 bg-black/20 backdrop-blur-sm text-white/90 font-medium text-[11px] tracking-[0.22em] uppercase hover:border-[#C9D1B5] hover:text-[#C9D1B5] hover:bg-black/40 transition-all duration-300"

            >

              See Full Portfolio

            </Link>

          </div>



          <div className="mt-12 pt-8 border-t border-white/10 flex flex-wrap items-center justify-center gap-4 text-[11px] text-[#A8B29C]/80 font-mono tracking-wider">

            <span>usmansajid25@gmail.com</span>

            <span className="hidden sm:inline text-white/20">·</span>

            <span>PK: +92 323 5464594</span>

            <span className="hidden sm:inline text-white/20">·</span>

            <span>DESK: +974 5053 8523</span>

            <span className="hidden sm:inline text-white/20">·</span>

            <span className="text-[#C9D1B5]/90">Response within 24 hours</span>

          </div>

        </div>

      </section>

    </MarketingLayout>

  );

}